import { render, staticRenderFns } from "./AppraisalRating.vue?vue&type=template&id=379db2ea"
import script from "./AppraisalRating.vue?vue&type=script&lang=js"
export * from "./AppraisalRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports